module.exports = __webpack_public_path__ + "static/avatar-80e3c66b56a5911036fd45a6771089a1.png";